import "./loader.scss";
import Logo from "../../asset/logo.svg";
export default function Loader() {
  return (
    <>
      <img src={Logo} className="App-logo" alt="logo" />
    </>
  );
}
